export const FAST_FORWARD_AMOUNT = 5;
